module.exports = __webpack_public_path__ + "static/img/MoneyRoadLogo3.c45799d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/MoneyRoadLogo3.png
// module id = 1462
// module chunks = 2